// extracted by mini-css-extract-plugin
export default {"root":"ujdtY","logo":"PBvRE","universeButtons":"yq0fl"};